import api from './api';
import { MovementType } from '../types/Movement';

const movementTypeService = {
  getAll: () => api.get<MovementType[]>('/movement-types'),
};

export default movementTypeService;
